import React from 'react';
import { CtaButton } from './CtaButton';
import { LadderLegend } from './LadderLegend';
import { PRODUCT_SET_IMAGE } from '../data/productImages';
const chips = ['6 Volumes', '90 Activities', '270 Ready-to-run versions', '15 · 30 · 45-min sessions', '5 Bonuses'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print or lead from your phone'];
export function Hero() {
  return <section className="w-full bg-cream text-ink" data-id="element-111" data-mp="12860zz2gicrl">
      <div className="mx-auto max-w-6xl px-5 pb-14 pt-5 sm:pb-20 sm:pt-12 lg:pt-16" data-id="element-112" data-mp="xae6qyecaek8">
        {/*
          Mobile order keeps the CTA above the first scroll:
          headline → photo → CTA → details.
          Desktop: headline, details and CTA on the left, photo on the right.
         */}
        <div className="grid gap-5 sm:gap-7 lg:grid-cols-[.9fr_1.1fr] lg:gap-x-12 lg:gap-y-6" data-id="element-113" data-mp="3d1ildbzsjgoh">
          <header className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-114" data-mp="3cz5weevm861x">
            <p className="text-[13px] font-semibold text-gold-deep" data-id="element-115" data-mp="3814alm6t1smr">
              Memory Care Activity Ready · for activity professionals
            </p>
            <h1 className="mt-2 font-display text-[28px] font-bold leading-[1.1] tracking-tight text-ink sm:mt-3 sm:text-5xl lg:text-[54px]" data-id="element-116" data-mp="3o858h3cjnn0v">
              Prep one activity.{' '}
              <span className="italic text-plum-mid" data-id="element-117" data-mp="3e9607lvoxtee">
                Run it three ways, for every resident in the room.
              </span>
            </h1>
          </header>

          <figure className="-mx-5 sm:mx-0 lg:col-start-2 lg:row-span-3 lg:row-start-1 lg:self-center" data-id="element-118" data-mp="30fybc1yzvc0e">
            <img src={PRODUCT_SET_IMAGE} alt="The six spiral-bound Memory Care Activity Ready volumes lined up on a wooden table, with residents doing an activity together in the background" width={1024} height={688} className="aspect-[1024/688] w-full object-cover sm:rounded-3xl sm:border sm:border-cream-line sm:shadow-card" data-id="element-119" data-mp="35akn468zn6l0" />
          </figure>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-120" data-mp="s2jp22e1eam5">
            <div className="w-full sm:max-w-md" data-id="element-121" data-mp="s44ifoom7nif">
              <CtaButton data-id="element-122" data-mp="nb1imyt8vhts">Get Memory Care Activity Ready</CtaButton>
            </div>
            <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[13px] text-ink-soft sm:justify-start" data-id="element-123" data-mp="iboywmxo6qvf">
              {micro.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-124" data-mp="db2ede3uydmq">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-125" data-mp="1azkqjd8dtslc" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="mt-4 lg:col-start-1 lg:row-start-2 lg:mt-0" data-id="element-126" data-mp="111yd6v6qe93h">
            <p className="max-w-xl text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-127" data-mp="x14nbw9qak7y">
              Six volumes and 90 activities, each one written at three rungs —
              DO, HELP and FEEL — so the residents who chat, the ones who need a
              hand, and the ones who respond mainly to touch and sound all have
              a way to take part in the same session.
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-128" data-mp="21awdua25atgy">
              {chips.map(chip => <li key={chip} className="rounded-full border border-cream-line bg-white px-3 py-1.5 text-[13px] font-semibold text-ink-soft" data-id="element-129" data-mp="269zi3saawvnv">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center border-t border-cream-line pt-8" data-id="element-130" data-mp="2kyvmnfd5fqjq">
          <LadderLegend data-id="element-131" data-mp="2p0h8hq7nvf62" />
          <p className="mt-4 max-w-md text-center text-sm text-ink-soft" data-id="element-132" data-mp="2ozz60bueo4pp">
            Written for activity directors, life enrichment and lifestyle
            coordinators, and recreation staff in memory care. No subscription,
            no certification required.
          </p>
        </div>
      </div>
    </section>;
}